import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { HostFamily, HostFamilyFilters } from '../../lib/types/models/host-family/host-family'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getHostFamilies(input?: PaginationRequest<HostFamilyFilters>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.hostFamilies.getAll.url, null),
        input
      )
    )
    .get<PaginationResponse<HostFamily>>()
}
